module.exports = __webpack_public_path__ + "img/chevron-left-black.03288ced.svg";